import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const button: SxStyle = {
  borderRadius: 0.5,
  fontSize: (p) => p.typography.caption,
};
